/** Storage keys on an origin we may share (STORY-138).
 *
 * `localStorage` is per origin, and the app can be served under a path on a host whose root
 * is another application's, so every key of ours carries the product slug (`storageKey`).
 * The keys below were written raw for a year and a teacher who used the app before the
 * change must not be signed out or lose a setting: the first read under the new name
 * copies the old value across and removes the old name, once. */
import { storageKey } from "../product";

/** The namespaced key for `name`, after moving any value still stored under `legacy`. */
export function nsKey(name: string, legacy: string = name): string {
  const key = storageKey(name);
  try {
    if (localStorage.getItem(key) === null) {
      const old = localStorage.getItem(legacy);
      if (old !== null) {
        localStorage.setItem(key, old);
        localStorage.removeItem(legacy);
      }
    }
  } catch {
    /* private mode or storage off: the caller's own try/catch handles the read */
  }
  return key;
}
